import { useDispatch, useSelector } from 'react-redux';
import { Form, Card } from '@deere/ux.uxframe-react';
import {  EMPTY_BODY, SCBM_SECCIO_CODES } from '../../utils/surveyLiterals'
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import { findAnswerIndex, getTranslation } from '../../utils/utils';
import React, { useState, useEffect } from 'react';
import store from '../../redux/store'
import {DebounceInput} from 'react-debounce-input';
import RadioGroup from '../../components/RadioGroup';
import { useTranslation } from 'react-i18next';

export default function AdditionalComments({ survey }) {

    const dispatch = useDispatch()
    const [answers, setAnswers] = useState([])
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [checkSection, setCheckSection] = useState("");
    const { t } = useTranslation();
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])
    }, [surveyResponse])

    if (!survey) return EMPTY_BODY;


    const section = survey.sections.find(e => e.code === SCBM_SECCIO_CODES.AC && e.active);  
    const questions = section && section.questions ? section.questions : null 

    const updateAnswer = (e, questionId) => {
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createTextArea(question) {
        let qDepIndex = findAnswerIndex(question.idQuestionDepends, answers);
        let questionIndex = findAnswerIndex(question.id, answers);
        if (question.idQuestionDepends && question.idQuestionDepends > 0) {
            return (qDepIndex >= 0 && answers[qDepIndex].answer >= question.idSelectionDependson) ? <Form.Group className="mb-4 pl-4">
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, question.id)} name={`${getTranslation(section, 'description')}-${question.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group> : null
        } else {
            return <Form.Group className="mb-4">
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <DebounceInput element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, question.id)} name={`${getTranslation(section, 'description')}-${question.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group>
        }
    }

    function createRadioSection(question) {
        return (<>
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <div><RadioGroup key={question.id} rgIndex={''} radioLabels={question ? question.selections : []}
                        updateAnswer={updateAnswer} question={question}
                        defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                        section={getTranslation(section, 'description')}
                        checkedProprietary={checkSection}/>
                    </div>                        
                </Form.Group>
             </>)
    }

    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}                    
            </Card.Title>                                 
                <>
                    {
                        <>
                            {
                              questions && questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((q,index) =>
                                    <Form.Row className="d-block mb-4" key={index}>
                                        {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                        {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                                    </Form.Row>
                                )
                            }
                        </>
                    }
                </>
            </Card.Body>
        </Card>
    </>)
}